import { Card, Col, Row, Spinner } from "react-bootstrap";
import PrimaryButton from "../../components/PrimaryButton";
import FileUploadComponent from "../../components/FileUploadComponent";
import i18n from "../../constants/Strings";

const UploadCSV = ({
  loading,
  fileName,
  setFileName,
  saveStatus,
  uploadFile,
  selectedFile,
  setSelectedFile,
  downloadSampleCSV,
}) => {
  const text = {
    rules: i18n.t("bulkUpload.rulesToUpload"),
    rulesTitle: i18n.t("bulkUpload.rulesTitle"),
  };
  return (
    <>
      <Card
        style={{
          width: "100%",
          height: "400px",
          overflow: "auto",
          marginBottom: "100px",
        }}
      >
        <Row className="">
          <div className="col-md">
            <div className="py-3 px-5">
              <h5>{text.rulesTitle}</h5>
              {text.rules.map((rule, index) => (
                <div>
                  <p className="text-left">{rule.title}</p>
                  <ol>
                    {rule.list.map((point, index) => (
                      <li key={index}>
                        <p className="text-left text-secondary">{point}</p>
                      </li>
                    ))}
                  </ol>
                </div>
              ))}

              <div className="row">
                <div className="col">
                  <h5 className="text-left">{"File Template"}</h5>
                  <h6 className="text-left text-secondary">{"Sample.csv"}</h6>
                </div>
                <div className="col d-flex align-items-center justify-content-end">
                  <a className="text-dark" href="#" onClick={downloadSampleCSV}>
                    {"Download"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Card>
      <Row>
        <div className="d-flex justify-content-center">
          <div className="px-4 w-50">
            <FileUploadComponent
              key={selectedFile ? selectedFile.name : ""}
              setSelectedFile={setSelectedFile}
              setFileName={setFileName}
              fileName={fileName}
              fileType={".csv"}
            />
          </div>
          <div>
            {loading ? (
              <Spinner />
            ) : (
              <PrimaryButton
                disabled={saveStatus}
                type="submit"
                text={"Save"}
                className="width-auto  "
                onClick={uploadFile}
              />
            )}
          </div>
        </div>
      </Row>
      <Row className="px-4 ">
        <Col className="d-flex justify-content-center m-4">
          <h4>Select a file to upload the initial inventory.</h4>
        </Col>
      </Row>
    </>
  );
};

export default UploadCSV;
